import { ReactNode, FC } from 'react'

import OriginLink from 'components/parts/originLink/originLink'

interface ILinkWrap {
  children: ReactNode
  href: string
  className?: string
  prefetch?: boolean
}

const LinkWrap: FC<ILinkWrap> = ({ children, href, ...props }: ILinkWrap) => {
  if (!href) {
    const formatedProps = { ...props, prefetch: undefined }
    return <a {...formatedProps}>{children}</a>
  }

  return (
    <OriginLink href={href} {...props}>
      {children}
    </OriginLink>
  )
}

export default LinkWrap
